module.exports = __webpack_public_path__ + "img/illu-dino.3aae0573.svg";